import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { Table } from 'components/patterns'
import TemplateCard from '../TemplateCard/TemplateCard'

export const DiffTemplateCard = styled(TemplateCard)(
  (props) => `
    &&&&.ant-card.ant-card-bordered {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
      background-color: ${themeColor('whitePrimary', props)};
      border: 1px solid ${themeColor('greyPrimary', props)};
    }
  `
)

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 5px;
`

export const DiffCountTitle = styled.div`
  font-size: 14px;
  margin-bottom: 20px;
  color: ${themeColor('blackPrimary')};
`

export const Count = styled.span`
  font-weight: bold;
`

export const DomainTitle = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: ${themeColor('blackPrimary')};
`

export const StyledTitle = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: ${themeColor('blackPrimary')};
`

export const StyledTable = styled(Table)`
  &&&&.ant-table
    ant-table-middle
    ant-table-fixed-header
    ant-table-scroll-position-left {
    border: 1px solid ${themeColor('greyPrimary')};
  }
  &&&&.chec-table
    > .ant-spin-nested-loading
    > .ant-spin-container
    > .ant-table-fixed-header
    > .ant-table-content
    > .ant-table-scroll
    > .ant-table-header {
    border: 1px solid ${themeColor('greyPrimary')};
  }
  &&&.ant-table-fixed-header
    > .ant-table-content
    > .ant-table-scroll
    > .ant-table-body {
    border: 1px solid ${themeColor('greyPrimary')};
    max-height: 500px;
  }
`

export const PtoDomainElement = styled.div`
  position: relative;
  display: flex;
  padding: 5px;
  margin: 14px 0px;
  width: 100%;
  height: 48px;
  border: 1px solid ${themeColor('greyPrimary')};
  box-sizing: border-box;
`
export const PtoDomainElementTitle = styled.div`
  position: relative;
  height: 22px;
  left: 20px;
  top: 8px;

  font-family: Arial;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;

  color: themeColor('black');
`

export const PtoDomainPopDetails = styled.div`
  position: absolute;
  top: 14px;
  right: 10px;
  color: ${themeColor('blueSecondary')};

  &:hover {
    cursor: pointer;
  }
`

export const PtoDomainNoFragments = styled.div`
  position: absolute;
  top: 14px;
  right: 10px;
`
